
import { useEffect, useState } from "react";

import { Dialog, DialogContent, Grid, Card, CardHeader, Typography, Divider, CardContent, DialogActions, Button, List, ListItem, ListItemText, Chip, Box, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, Alert, Tooltip } from "@mui/material";

import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

import { CircularProgressIndicator } from "../components/CircularProgressIndicator";

import { DialogContentStyle, DialogActionsStyle } from "../styles/DialogStyle";

import { CambiarContrasena, ObtenerPerfil } from "../connections/admin/UsuarioConnection";

import { defaultPerfil, PerfilProps } from "../interfaces/admin/UsuarioInterface";

interface Props {
    openDialog:              boolean;
    handleCloseDialog:       () => void;
}
type ErrorType = 'warning' | 'success' | 'error';

interface Error {
    type?:          ErrorType;
    descripcion?:   string;
}

export const DialogPerfil = ( { openDialog, handleCloseDialog }: Props ) => {

    const [usuario, setUsuario] = useState<PerfilProps>( defaultPerfil );
    const [loading, setLoading] = useState( true );
    const [loadingContrasena, setLoadingContrasena] = useState( false );

    const [viewContrasena, setViewContrasena] = useState( false );    
    const [contrasena, setContrasena] = useState( '' );

    const [errors, setErrors] = useState<Error>({ });
       
    const handleChangePassword = async () => {       
        
        setErrors( {} );
    
        if( !contrasena ){
            setErrors({ type: 'success', descripcion: 'Debe escribir una contraseña' });                        
            return;
        } 
        else{

            setLoadingContrasena( true );

            await CambiarContrasena({ contrasena }).then( resp => {
                
                const { success, message } = resp;

                if( success ){       
                        
                    setTimeout(() => {

                        setErrors({ type: 'success', descripcion: 'Se cambió la contraseña correctamente' });                        
                        setLoadingContrasena( false );

                    }, 400);
                    
                }
                else{

                    setTimeout(() => {    

                        setErrors({ type: 'error', descripcion: message });       
                        setLoadingContrasena( false );

                    }, 400);
                    
                }
            });   

        }

    }

    useEffect(() => {
      
        async function obtener() {

            setLoading( true );
            
            await ObtenerPerfil().then( resp => {

                setTimeout(() => {

                    setUsuario( resp );
                    setContrasena( resp.contrasena );
                    setLoading( false );
                    
                }, 700);

            });

        }
    
        if( openDialog){
            obtener();        
        }

    }, [ openDialog])    

    return (
        <>
            
            <Dialog open={ openDialog } fullWidth={true} maxWidth='md'>       
                
                <DialogContent sx={ DialogContentStyle }>    

                    {
                        loading
                        ?
                            <Box sx={{ textAlign: 'center', alignItems: 'center', minHeight: 450 }}>
                                <CircularProgressIndicator mt={25} />
                            </Box>
                        :
                            <Grid container spacing={3}>                      

                                <Grid size={{ xs: 12, md: 12 }}>

                                    <Card>
                                        <CardHeader sx={{ backgroundColor: (theme) => theme.palette.primary.main }} subheader={ <Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Información de la cuenta</Typography> }/>
                                        
                                        <Divider />
                                    
                                        <CardContent>

                                            <Grid container spacing={1}>                                        

                                                <Grid size={{ md: 6, xs: 12 }}>
                                               
                                                    <ListItem sx={{ px: 0, py: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Nombre: </Typography> }
                                                            secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { usuario.nombres } </Typography> }
                                                        />

                                                    </ListItem>

                                                </Grid>
                                             
                                                <Grid size={{ md: 6, xs: 12 }}>

                                                    <ListItem sx={{ px: 0, py: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Apellidos: </Typography> }
                                                            secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { usuario.apellido1 } { usuario.apellido2 } </Typography> }
                                                        />

                                                    </ListItem>

                                                </Grid>

                                                {
                                                    usuario.puesto
                                                    &&
                                                        <Grid size={{ md: 6, xs: 12 }}>

                                                            <List disablePadding>                                                

                                                                <ListItem sx={{ px: 0, py: 0 }}>

                                                                    <ListItemText
                                                                        sx={{ mr: 2 }}
                                                                        primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Puesto: </Typography> }
                                                                        secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { usuario.puesto.toLocaleUpperCase() } </Typography> }
                                                                    />

                                                                </ListItem>

                                                            </List>

                                                        </Grid>
                                                }  

                                                {
                                                    usuario.unidad
                                                    &&
                                                        <Grid size={{ md: 6, xs: 12 }}>
                                            
                                                            <List disablePadding>                        
                                                                
                                                                <ListItem sx={{ px: 0, py: 0 }}>

                                                                    <ListItemText
                                                                        sx={{ mr: 2 }}
                                                                        primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Unidad de gestión asignada: </Typography> }
                                                                        secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { usuario.unidad.toUpperCase() } </Typography> }
                                                                    />

                                                                </ListItem>

                                                            </List>

                                                        </Grid>
                                                }

                                                {
                                                    usuario.delegado
                                                    &&
                                                        <Grid size={{ md: 6, xs: 12 }}>
                                            
                                                            <List disablePadding>                        
                                                                
                                                                <ListItem sx={{ px: 0, py: 0 }}>

                                                                    <ListItemText
                                                                        sx={{ mr: 2 }}
                                                                        primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Bandeja delegada a: </Typography> }
                                                                        secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { usuario.delegado.toUpperCase() } </Typography> }
                                                                    />

                                                                </ListItem>

                                                            </List>

                                                        </Grid>
                                                }

                                                <Grid size={{ md: 10, xs: 10 }}>

                                                    <FormControl variant="outlined" fullWidth sx={{ mt: 1 }}>
                                                        <InputLabel shrink>Contraseña</InputLabel>
                                                        <OutlinedInput
                                                            notched
                                                            label="Contraseña"
                                                            name="contrasena"
                                                            placeholder='Escribe la nueva contraseña'
                                                            type={ viewContrasena ? 'text' : 'password'}
                                                            value={ contrasena }                                
                                                            onChange={ (e) => setContrasena( e.target.value ) }
                                                            endAdornment={
                                                                <InputAdornment position="end">
                                                                    <IconButton onClick={ () => setViewContrasena( (prev) => !prev ) } edge="end" >
                                                                        {
                                                                            viewContrasena
                                                                            ?
                                                                                <VisibilityOffIcon />
                                                                            :
                                                                                <VisibilityIcon />
                                                                        }                                                    
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            }
                                                        />
                                                    </FormControl>    

                                                </Grid>

                                                <Grid size={{ md: 2, xs: 2 }} alignContent={'center'} textAlign={'center'}>   

                                                    <Button           
                                                        fullWidth
                                                        variant="contained"                                          
                                                        color="primary"
                                                        disabled={ contrasena === '' }
                                                        loading={ loadingContrasena }
                                                        onClick={ handleChangePassword }
                                                    >
                                                        Guardar
                                                    </Button>

                                                </Grid>

                                                {   
                                                    errors.descripcion 
                                                    &&            
                                                        <Grid size={{ md: 12, xs: 12 }}>
                                                            <Alert severity={ errors.type ?? 'error' } variant="filled" sx={{ mt: 1 }}> { errors.descripcion } </Alert>       
                                                        </Grid>                                  
                                                }    

                                            </Grid>                                            

                                        </CardContent>

                                    </Card>

                                </Grid>      

                                <Grid size={{ xs: 12, md: 12 }}>  

                                    <Card>
                                        <CardHeader sx={{ backgroundColor: (theme) => theme.palette.primary.main }} subheader={ <Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Permisos </Typography> }/>
                                        
                                        <Divider />
                                    
                                        <CardContent>
                                        
                                            <Grid container spacing={2} textAlign={'center'}>

                                                {
                                                    usuario.roles?.map ( ( { descripcion }, index ) => (

                                                        <Grid key={ index } size={{ md: 4, xs: 12 }}>

                                                            <Tooltip title={ descripcion }>

                                                                <Chip 
                                                                    variant="outlined" 
                                                                    color="secondary"
                                                                    sx={{ py: 2, px: 1, width: '100%' }}
                                                                    label={ descripcion }
                                                                />

                                                            </Tooltip>

                                                        </Grid>

                                                    ))
                                                }

                                                {
                                                    usuario.roles?.length === 0
                                                    &&
                                                        <Grid size={{ md: 12, xs: 12 }} sx={{ textAlign: 'center' }}>
                                                            <Typography variant="subtitle2" color="secondary" fontSize={14}>No tiene permisos asignados</Typography>
                                                        </Grid>
                                                }

                                            </Grid>
                                            
                                        </CardContent>

                                    </Card>

                                </Grid>              
                                
                            </Grid>     
                    }  

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>

                    <Button 
                        color="secondary"
                        onClick={ () => { handleCloseDialog(); setViewContrasena( false); setErrors( {} ); } }
                    > 
                        Cancelar 
                    </Button>

                </DialogActions>

            </Dialog>

        </>
    )
}
